<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import validations, { getSharedFileNameErrorMessage } from './validations';
import { useVuelidate } from '@vuelidate/core';
import { FILE_ACCEPTED_TYPES } from './constants';
import FileUpload from 'dashboard/components-next/input/FileUpload.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    FileUpload,
    NextButton,
  },
  emits: ['close'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      file: null,
      name: '',
    };
  },
  validations,
  computed: {
    ...mapGetters({
      uiFlags: 'sharedFiles/getUIFlags',
    }),
    sharedFileNameErrorMessage() {
      const mappingErrorMessage = {
        REQUIRED_ERROR: this.$t('SHARED_FILE_MGMT.FORM.NAME.REQUIRED_ERROR'),
        VALID_ERROR: this.$t('SHARED_FILE_MGMT.FORM.NAME.VALID_ERROR'),
        LENGTH_ERROR: this.$t('SHARED_FILE_MGMT.FORM.NAME.LENGTH_ERROR'),
      };

      return mappingErrorMessage[getSharedFileNameErrorMessage(this.v$)];
    },
    fileAcceptedTypes() {
      return FILE_ACCEPTED_TYPES;
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    handleImageUpload(file) {
      this.file = file;
      this.v$.file.$touch();
    },
    async uploadFile() {
      try {
        const formData = new FormData();
        formData.append('name', this.name);
        formData.append('file_upload', this.file);
        await this.$store.dispatch('sharedFiles/create', formData);
        useAlert(this.$t('SHARED_FILE_MGMT.ADD.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const errorMessage =
          error.message || this.$t('SHARED_FILE_MGMT.ADD.API.ERROR_MESSAGE');
        useAlert(errorMessage);
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="$t('SHARED_FILE_MGMT.ADD.TITLE')"
      :header-content="$t('SHARED_FILE_MGMT.ADD.DESC')"
    />
    <form class="flex flex-wrap mx-0 w-full" @submit.prevent="uploadFile">
      <woot-input
        v-model="name"
        :class="{ error: v$.name.$error }"
        class="w-full label-name--input"
        :label="$t('SHARED_FILE_MGMT.FORM.NAME.LABEL')"
        :placeholder="$t('SHARED_FILE_MGMT.FORM.NAME.PLACEHOLDER')"
        :error="sharedFileNameErrorMessage"
        data-testid="shared-file-name"
        @input="v$.name.$touch"
        @blur="v$.name.$touch"
      />

      <FileUpload
        :label="$t('SHARED_FILE_MGMT.FORM.FILE.LABEL')"
        :accept="fileAcceptedTypes"
        @change="handleImageUpload"
      />

      <div class="flex items-center justify-end w-full gap-2 px-0 py-2">
        <NextButton
          faded
          slate
          type="reset"
          :label="$t('SHARED_FILE_MGMT.FORM.CANCEL')"
          @click.prevent="onClose"
        />
        <NextButton
          type="submit"
          data-testid="label-submit"
          :label="$t('SHARED_FILE_MGMT.FORM.CREATE')"
          :disabled="v$.name.$invalid || v$.file.$invalid || uiFlags.isCreating"
          :is-loading="uiFlags.isCreating"
        />
      </div>
    </form>
  </div>
</template>
